import { Request } from "./request";

export interface OrganizationParams {
  orgNameOrCode?: string;
  orgProperty?: number;
  osIds?: string;
  pn?: number;
  ps?: number;
}

export function OrganizationPage(params: OrganizationParams): Request {
  return {
    url: "/api/data/center/organization/list",
    method: "POST",
    body: params,
  };
}

export function OrganizationDetail(id: number): Request {
  return {
    url: "/api/data/center/organization/info",
    method: "GET",
    params: {
      orgId: id,
    },
  };
}
